(function ($, Drupal) {
  Drupal.behaviors.messagePopup = {
    attach: function (context, settings) {
      context = context || document;
      var pathname = window.location.pathname;
      var validElement = context.querySelector('.modal-container .messages.messages--status');
      var message = context.querySelector('.messages.messages--status');

      if ((validElement) || (message == null || typeof message == 'undefined')) {
        return;
      }

      if (location.href.match(/(productos\/*|cart)/) || pathname == '/') {
        
          var container = document.createElement('div');
          container.setAttribute('class', 'modal-container');
          var modal = document.createElement('div');
          modal.setAttribute('class', 'modal-message--status');

          var close = document.createElement('span');
          close.setAttribute('class', 'modal-close');
          message.appendChild(close);

          modal.append(message.cloneNode(true));

          container.append(modal);

          message.parentNode.replaceChild(container, message);

          $('.modal-container').fadeIn();

          window.onclick = function (event) {
            var close = context.querySelector('.messages.messages--status .modal-close');
            if (event.target == container || event.target == close) {
              $('.modal-container').fadeOut();
            }
          }
        
      }

    }
  };
})(jQuery, Drupal);